import ToastyLogo from './ToastyLogo'

export const SidebarLogo = () => {
  return (
    <>
      <ToastyLogo />
    </>
  )
}
